import ExpandedView from './expanded-view';

export default ExpandedView; 